import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_MERGED_CUSTOMERS_CONTRACTORS';

export async function getAllMergedCustomersContractors(
    userToken: string,
    params: string,
    page: number
) {
    try {
        const response = await axios.get(

            `${URL}/merged-customers-contractors/?page=${page}&order=name&${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récuperation de la liste des clients et fournisseurs.',
            error: error
        });
    }
}
